import Vue from "vue";
var myVue = new Vue();
myVue.emit = myVue.$emit;
myVue.on = myVue.$on;
export default myVue;



// WEBPACK FOOTER //
// ./src/js/emit.js